import { apiGet } from "../client";

interface IntercomIdentityResponse {
	userHash: string;
}

export function getIntercomUserHash(): Promise<IntercomIdentityResponse> {
	return apiGet<IntercomIdentityResponse>("intercom/identity");
}
